import { render, staticRenderFns } from "./Selectors3Pv.vue?vue&type=template&id=3b04ab8c&"
import script from "./Selectors3Pv.vue?vue&type=script&lang=js&"
export * from "./Selectors3Pv.vue?vue&type=script&lang=js&"
import style0 from "./Selectors3Pv.vue?vue&type=style&index=0&id=3b04ab8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports